import styled from 'styled-components'

export const Products = styled.div`
  background: #F2F6F7;
  padding: 0px 0 90px;

  .grid-products-br {
    display: grid;
    grid-gap: 20px;
    margin-bottom: 40px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: 
      "banktransfer banktransfer pix"
      "banktransfer banktransfer improvements";

    .gd-banktransfer { grid-area: banktransfer; }
    .gd-pix { grid-area: pix; }
    .gd-manage { grid-area: manage; }
    .gd-improvements { grid-area: improvements; }

    .card {
      background-color: #fff;
      border-radius: 6px;
      padding: 25px;
      -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    }

    .item--transfer {
      .item__text {
        width: 50%;
        z-index: 9;
        position: relative;
      }

      .item__image {
        width: 390px;
        height: 289px;
        position: absolute;
        right: -50px;
        bottom: 0px;
      }
    }
  }

  .grid-products {
    display: grid;
    grid-gap: 20px;
    margin-bottom: 40px;
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas: 
      "banktransfer banktransfer banktransfer"
      "pix manage improvements";

    .gd-banktransfer { grid-area: banktransfer; }
    .gd-pix { grid-area: pix; }
    .gd-manage { grid-area: manage; }
    .gd-improvements { grid-area: improvements; }

    .card {
      background-color: #fff;
      border-radius: 6px;
      padding: 25px;
      -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
      box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    }
  }

  @media screen and (max-width: 1000px) {
    .grid-products {
      grid-template-areas: 
      "banktransfer banktransfer banktransfer"
      "pix pix pix"
      "manage manage manage"
      "improvements improvements improvements";
    }

    .grid-products-br {
      grid-template-areas: 
      "banktransfer banktransfer banktransfer"
      "pix pix pix"
      "improvements improvements improvements";

      .item--transfer {
        .item__title,
        .item__text {
          width: 100%;
        }
  
        .item__image {
          display: none;
        }
      }
    }
  }

  .title {
    font-size: 36px;
    font-weight: 900;
    color: #000;
    text-align: left;
    margin-bottom: 30px;
  }

  .subtitle {
    font-size: 24px;
    color: #000;
    text-align: left;
    margin-top: 30px;
    margin-bottom: 0px;
    font-weight: bold;
  }

  .subtitle_2 {
    font-size: 18px;
    color: #000;
    text-align: left;
    margin-top: 0px;
    margin-bottom: 10px;
  }

  .grid {
    display: flex;
    flex-direction: row;
    margin-left: -10px;

    &__column {
      display: flex;
      
      &-1 { 
        flex: 12;
        flex-direction: column;
      }
      
      &-2 { 
        flex: 10;
        flex-direction: column;
        margin-right: -10px;
      }  

      &-3 { 
        flex: 2;
      } 

      &-4 { 
        flex: 2;
        flex-direction: column;
        margin-right: -10px;
      } 
    }
  }

  .item {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #fff;
    border-radius: 6px;
    padding: 25px;
    margin: 10px;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);

    &--without-margin {
      margin: 0;
    }

    &--dash {
      background: var(--color-primary);
      display: flex;
      flex-direction: column;

      .item__title,
      .item__text,
      .item__list {
        width: 65%;
        z-index: 9;
        position: relative;
      }

      .item__links {
        a {
          text-decoration: none;
        }
        
        button {
          background: #fff;
          height: 40px;
          padding: 0 20px;
          font-size: 16px;
          margin: 0;
          border-radius: 20px;
          /* color: var(--color-secondary) !important; */
        }
      }

      .item__title {
        font-weight: 900;
        color: #fff;
      }

      .item__text,
      .item__text p {
        color: #fff;
      }

      .item__list {
        margin-left: 20px;
        margin-top: 0px;
        flex: auto;
        
        li {
          color: #fff;
        }
      }
    }

    &--conciliation {
      background: var(--color-primary);
      // background: #2F2F2F;

      .item__title {
        color: #fff;
        font-weight: 900;
      }
      .item__text,
      .item__text p {
        color: #fff;
      }
      .item__links button {
        color: var(--color-secondary) !important;

        svg {
          fill: var(--color-secondary) !important;
        }
      }

      .item__links {
        a {
          text-decoration: none;
        }
        
        button {
          background: #fff;
          height: 40px;
          padding: 0 20px;
          font-size: 16px;
          margin: 0;
          border-radius: 20px;
          /* color: var(--color-secondary) !important; */
        }
      }

      .item__list {
        margin-left: 20px;
        margin-top: 0px;
        flex: auto;
        
        li {
          color: #fff;
        }
      }
    }

    &--receipt {
      position: relative;

      .item__title,
      .item__text {
        width: 60%;
        z-index: 9;
        position: relative;
      }

      .item__image {
        width: 180px;
        height: 163px;
        position: absolute;
        right: 20px;
        bottom: 0px;
      }
    }

    &--transfer {
      position: relative;
      overflow: hidden;

      .item__title,
      .item__text {
        width: 65%;
        z-index: 9;
        position: relative;
      }

      .item__image {
        width: 390px;
        height: 289px;
        position: absolute;
        right: 0px;
        bottom: -20px;
      }
    }

    &--kyc {
      flex: auto;
      background-repeat: no-repeat;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .item__title,
      .item__text {
        width: 60%;
      }

      .item__image {
        width: 150px;
        height: 301px;
        position: absolute;
        right: 20px;
        bottom: -20px;
      }

      .item__text { flex: auto; }
    }

    &__title {
      font-size: 20px;
      color: #000;
      margin-bottom: 15px;

      strong {
        font-weight: bold;
      }
    }

    &__text {
      flex: 1;

      strong {
        font-weight: bold;
      }
    }

    &__links {
      display: flex;
      flex-direction: column;
      align-items: self-start;
      margin-top: 20px;

      a {
        text-decoration: none;
      }

      button {
        background: transparent;
        border: 0;
        outline: none;
        cursor: pointer;
        font-weight: 700;
        color: var(--color-primary);
        font-size: 16px;
        display: flex;
        align-items: center;
        margin-top: 3px;

        svg {
          fill: var(--color-primary);
          width: 14px;
          height: auto;
          margin-top: 5px;
          margin-left: 6px;
          transition: all .3s;
        }

        &:hover {
          svg {
            margin-left: 10px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 1000px) {
    padding: 40px 0 120px;

    .title {
      font-size: 24px;
      margin-bottom: 10px;
    }

    .grid {
      flex-direction: column;
      margin-right: -10px;

      &__column-1-inside {
        flex-direction: column;
      }

      &__column-2 { margin-right: 0 }
      &__column-4 { margin-right: 0 }
    }

    .item {
      &--dash {
        .item__title,
        .item__text,
        .item__list {
          width: 100%;
        }
      }

      &--transfer {
        // padding-bottom: 0;

        .item__title,
        .item__text {
          width: 100%;
        }
        
        .item__image {
          position: relative;
          right: auto;
          bottom: auto;
          margin-top: 30px;
          height: 220px;
        }
      }

      &--receipt {
        padding-bottom: 0;
        
        .item__title,
        .item__text {
          width: 100%;
        }

        .item__image {
          position: relative;
          right: auto;
          bottom: auto;
          margin: 0 auto;
          margin-top: 30px;
        }
      }

      &--kyc {
        padding-bottom: 0;

        .item__title,
        .item__text {
          width: 100%;
        }
        
        .item__image {
          position: relative;
          right: auto;
          bottom: auto;
          height: 220px;
          margin: 30px auto 0;
        }
      }
    }
  }
`
